import React, { useEffect, useState } from 'react'
import { DetallesSucursales, getSession, getOrDeleteRequest } from "../utils/utils";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faCircleUser, faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import axios from 'axios';  
import Cookies from 'js-cookie';

import DataTableComponent from './DataTableComponent/DataTableComponent';

const CRUDSucursales = () => {
    const [loading, setLoading] = useState(true);
    const [sucursales, setSucursales] = useState([]);
    const [search, setSearch] = useState("");

    const columns = [
		{
			name: '#',
			width: '50px',
			selector: (row) => row.id
		},
		// {
        //     name: '# de Autorización',
        //     width: '180px',
        //     selector: (row) => row.id_autorizacion
        // },
        {
            name: 'Encargado',
            width: '190px',
            selector: (row) => row.nombre_encargado
        },
        {
            name: 'Correo electrónico',
            width: '260px',
            selector: (row) => row.correo
        },
        {
            name: 'Sucursal',
            width: '300px',
            selector: (row) => row.nombre_empresa
        },
		{
            name: 'NIT de la sucursal',
            width: '190px',
            selector: (row) => row.nit_empresa
        },
		// {
        //     name: 'Estado',
        //     width: '110px',
        //     selector: (row) => {
		// 		return row.status === 1 ? 
		// 			<span className="bg-green-100 text-green-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded-full dark:bg-green-200 dark:text-green-900">
		// 				Activo
		// 			</span>
		// 		: 
		// 			<span className="bg-red-100 text-red-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded-full dark:bg-red-200 dark:text-red-900">
		// 				Inactivo
		// 			</span>
		// 		;
		// 	}
        // },
    ];

    const getSucursales = async (page = 1, items = 10, search = null) => {
        setLoading(true);
                
        let uri = search ? `empresa/sucursales?page=${page}&items=${items}&search=${search}` : `empresa/sucursales?page=${page}&items=${items}`;
        let response = await getOrDeleteRequest(
            uri,
            'GET',
        );
        
        if (response.type === 'success') {
            setSucursales(response.data);
        } else {
            setSucursales([]);
        }
        setLoading(false);
    }

    useEffect(function () {
        if (!loading) return;
        getSucursales();
    }, []);

    const eliminarSucursal = async (id) => {

        let session = Cookies.get("AuthToken");
        let uri = process.env.REACT_APP_API_URL + `empresa/sucursalesEmpresa/${id}`;

        let config = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${session}`,
            }
        };

        console.log(id, 'e')

        Swal.fire({
            title: "¿Estás seguro de borrar esta sucursal?",
            text: "¡Esta acción no se puede deshacer!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Sí, eliminar",
            cancelButtonText: "Cancelar",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await axios.delete(uri, config);
                    setSucursales((prevSucursales) => prevSucursales.filter((sucursal) => sucursal.id !== id));
                    Swal.fire("¡Eliminado!", "La sucursal ha sido eliminada.", "success");
                } catch (error) {
                    console.error("Error al eliminar sucursal", error);
                    Swal.fire("Error", "No se pudo eliminar la sucursal.", "error");
                }
            }
        });
    };

    const searcher = (e) => {
        setSearch(e.target.value);
    }

    return (
        <>
            <div className="w-auto h-full py-10 px-3">
				<div className='flex flex-col justify-center w-auto h-auto items-center text-lg'>
					<div className="flex flex-col justify-center w-full mb-5">
						<div className="flex flex-row w-full justify-start items-start p-4">
							<Link to="/Mantenimiento" className="flex justify-start">
								<button className="bg-white border-4 border-[#0E7FA0] font-medium drop-shadow-2xl shadow-2xl text-white w-full rounded-full w-[50px] h-[50px] p-[12px]"><FontAwesomeIcon icon={faArrowLeft} className='text-[#0E7FA0] text-lg' /></button>
							</Link>
							<div className="flex flex-col w-full px-3 justify-between">
								<h1 className="text-4xl font-bold text-[#0E7FA0] text-start mb-2">
                                    Sucursales
                                </h1>
								<p className="text-base">
									Está sección para el mantenimiento y visualización de las sucursales de las empresas registradas.
								</p>
							</div>
						</div>
					</div>
				</div>
				<div className='h-full w-auto mx-6'>
					<DataTableComponent
						nameTable={"Sucursales"}
						data={sucursales}
						columns={columns}
						loading={loading}
						setLoading={setLoading}
						reload={getSucursales}
						toEdit={'/EditarSucursal/'}
						toDelete={'empresa/sucursalesEmpresa/'}
					/>
				</div>
			</div>
        </>
    )
}

export default CRUDSucursales;
